<template>
  <CFlex v-if="diagnostic">
    <div>
      <div v-if="diagnostic.complaint">
        <CIcon name="warning-alt"/>
        {{ diagnostic.complaint }}
      </div>

      <div v-if="diagnostic.conditions">
        <CIcon name="info"/>
        {{ diagnostic.conditions }}
      </div>
    </div>

    <CButton v-if="isPresent(diagnostic.id) && context" theme="ghost-primary" @click.prevent="edit">
      <CIcon name="compose-pen"/>
    </CButton>
  </CFlex>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import DossierModals from '@/dossier/services/DossierModals';
  import MediaContext2 from '@/general/models/MediaContext2';
  import CFlex from '@/shared/components/CFlex.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import { isPresent, present } from '@/shared/utils/typescript';
  import Job from '../models/Job';
  import JobContext from '../models/JobContext';
  import DiagnosticService from '../services/DiagnosticService';

  const props = defineProps<{
    job: Job;
    context?: JobContext;
    mediaContext?: MediaContext2;
  }>();

  const diagnostic = computed(() => props.job.getComplaintDiagnostic());

  async function edit() {
    const context = present(props.context);
    await DiagnosticService.loadByJob(props.job, context.dossier.id);
    DossierModals.diagnostic(present(diagnostic.value), context, props.mediaContext, props.job);
  }
</script>